import { render, staticRenderFns } from "./chateau-la-gurgue.vue?vue&type=template&id=3ea3328a&scoped=true"
import script from "./chateau-la-gurgue.vue?vue&type=script&lang=js"
export * from "./chateau-la-gurgue.vue?vue&type=script&lang=js"
import style0 from "./chateau-la-gurgue.vue?vue&type=style&index=0&id=3ea3328a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea3328a",
  null
  
)

export default component.exports